module.exports = __webpack_public_path__ + "img/attach_black.383ceb48.svg";